import { render, staticRenderFns } from "./ApprovalWrite.vue?vue&type=template&id=571b065a&scoped=true&"
import script from "./ApprovalWrite.vue?vue&type=script&lang=js&"
export * from "./ApprovalWrite.vue?vue&type=script&lang=js&"
import style0 from "./ApprovalWrite.vue?vue&type=style&index=0&id=571b065a&prod&scoped=true&lang=css&"
import style1 from "./ApprovalWrite.vue?vue&type=style&index=1&id=571b065a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "571b065a",
  null
  
)

export default component.exports